export enum PeriodTypes {
  Period1 = 1,
  Period2 = 2,
  Period3 = 3,
  Period4 = 4,
  Period5 = 5,
  Period6 = 6,
  Period7 = 7,
  Period8 = 8,
  Period9 = 9,
  ExtraPeriod0 = 10,
  ExtraPeriod1 = 11,
  ExtraPeriod2 = 12,
  ExtraPeriod3 = 13,
  ExtraPeriod4 = 14,
  ExtraPeriod5 = 15,
  ExtraPeriod6 = 16,
  ExtraPeriod7 = 17,
  ExtraPeriod8 = 18,
  ExtraPeriod9 = 19,
  ExtraPeriod10 = 20,
}
